import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { State } from 'store/types';
import { operators as focusFeedOperators } from 'store/focus/feed';
import FocusFeedDefinitionSocial from './FocusFeedDefinitionSocial';
import { ScopeSocial, SocialExpressionsType, ProfileExpressionsType } from 'class/Feed';

import { operators } from 'store/focus/feed/definition/social';
import selectors from 'store/focus/feed/definition/social/selectors';
import { DispatchProps, StateProps } from './types';

const mapStateToProps = (state: State): StateProps => ({
	definition: state.focus.feed.social.definition,
	loadingProfiles: state.focus.feed.social.loadingProfiles,
	errorProfiles: state.focus.feed.social.errorProfiles,
	instagramAccounts: selectors.getInstagramAccountsToSelect(state)
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
	onClearErrorProfiles: () => dispatch(operators.clearErrorProfiles()),
	onChangeMainQuery: (q: string) => dispatch(operators.changeMainQuery({ q })),
	onChangeMainScope: (scope: ScopeSocial[]) => dispatch(operators.changeMainScope({ scope })),
	onToggleEnableMainQuery: (enabled: boolean) => dispatch(operators.toggleEnableMainQuery({ enabled })),
	onSetMainExpressionError: (hasError: boolean) => dispatch(operators.setMainExpressionError({ hasError })),
	onFetchSearch: () => dispatch(focusFeedOperators.fetchSearch()),
	onChangeQuery: (q: string, type: SocialExpressionsType, index: number) => dispatch(operators.changeQuery({ q, type, index })),
	onToggleEnableQuery: (enabled: boolean, type: SocialExpressionsType, index: number) => dispatch(operators.toggleEnableQuery({ enabled, type, index })),
	onChangeScope: (scope: ScopeSocial[], type: SocialExpressionsType, index: number) => dispatch(operators.changeScope({ scope, type, index })),
	onAddExpression: (type: SocialExpressionsType) => dispatch(operators.addExpression({ type })),
	onAddProfileExpression: (type: ProfileExpressionsType) => dispatch(operators.addProfileExpression({ type })),
	onSetExpressionError: (hasError: boolean, type: SocialExpressionsType, index: number) => dispatch(operators.setExpressionError({ hasError, type, index })),
	onRemoveAllProfileExpressions: (type: SocialExpressionsType) => dispatch(operators.removeAllProfileExpressions({ type })),
	onRemoveExpression: (type: SocialExpressionsType, index: number) => dispatch(operators.removeExpression({ type, index })),
	onRemoveProfileExpression: (type: ProfileExpressionsType, index: number) => dispatch(operators.removeProfileExpression({ type, index })),
	onToggleInstagramAccount: account => dispatch(operators.toggleDefinitionInstagramAccount({ account })),
	onChangeQueryProfile: (url: string, type: ProfileExpressionsType, index: number) => dispatch(operators.changeQueryProfile({ url, type, index })),
	onSetThreshold: (channel, threshold) => dispatch(operators.setThreshold({ channel, threshold })),
	onSearchMultipleProfiles: (urls: string[], type: ProfileExpressionsType) => dispatch(operators.searchMultipleProfiles({ urls, type })),
	onSearchProfile: (url: string, type: ProfileExpressionsType, index: number) => dispatch(operators.searchProfile({ url, type, index }))
});

export default connect(mapStateToProps, mapDispatchToProps)(FocusFeedDefinitionSocial);
